import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { categories } from './config';
import Categories from './Components/Categories';
import useParamsRoute from '@profile/src/hooks/useRouteParams';
import { CategoryKey, MenuItem, navigateToHistoryPage } from '@profile/src/utils/navigate';

const History = ({
  className
}) => {
  var _selectedTab$renderCa;

  const {
    category = CategoryKey.BoxHistory
  } = useParamsRoute();
  const selectedTab = categories.find(categoryItem => categoryItem.key === category);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement(Categories, {
    className: styles.category,
    onClickItem: item => navigateToHistoryPage({
      urlSearch: '',
      tab: MenuItem.HISTORY,
      category: item.key
    }),
    selectedKey: category,
    data: categories
  }), selectedTab === null || selectedTab === void 0 ? void 0 : (_selectedTab$renderCa = selectedTab.renderCategory) === null || _selectedTab$renderCa === void 0 ? void 0 : _selectedTab$renderCa.call(selectedTab));
};

export default History;